import { Section } from "views/applications-id-report/components/Section";
import VerifiedIcon from "shared/icons/verified-icon.svg?react";
import {
  PayrollEmployment,
  VerifiedIncomeReport
} from "types/landlord/reports";

import { UniversalTable } from "views/applications-id-report/slices/IncomeReportSlice/components/UniversalTable";
import { ColumnDef } from "@tanstack/react-table";
import { useMemo } from "react";
import { verifiedIncomeSourceColumns } from "views/applications-id-report/slices/IncomeReportSlice/components/VerifiedIncomeSourcesTableExpander/columns/verifiedIncomeSourceColumns";
import {
  getDateRangeAndDiffByDocType,
  getIncomeSourceInfo
} from "../components/VerifiedIncomeSourcesTableExpander/utils";
import { formatToCurrency } from "utils/currency";

interface VerifiedIncomeSourcesProps {
  report?: VerifiedIncomeReport;
}
export const VerifiedIncomeSources = ({
  report
}: VerifiedIncomeSourcesProps) => {
  const { bank_income, document, employment, items } = report || {};

  const tableData = useMemo(() => {
    if (report?.income_source_type === "payroll" && items?.length)
      return items.map((i) => ({
        ...i,
        income_source_type: report.income_source_type
      }));

    if (report?.income_source_type === "bank" && bank_income?.length)
      return bank_income.flatMap((bi) =>
        bi.items.flatMap((i) =>
          i.bank_income_sources.map((bis) => ({
            ...bis,
            institutionMetaData: i.institution_metadata,
            income_source_type: report.income_source_type
          }))
        )
      );

    return (
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      document?.income_sources?.map((doc) => ({
        ...doc,
        income_source_type: report?.income_source_type,
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        docType: document?.type
      })) || []
    );
  }, [report]);

  return (
    <Section
      sectionTitle="Verified income sources"
      icon={<VerifiedIcon />}
      maxWidth="none"
    >
      <UniversalTable
        tableColumns={verifiedIncomeSourceColumns as ColumnDef<unknown, any>[]}
        tableData={tableData}
        employment={employment as PayrollEmployment[]}
        sectionName="Verified income sources"
        rowHeight={76}
        mobileRow={(row) => {
          const incomeSource = getIncomeSourceInfo(row.original);
          const dateRange = getDateRangeAndDiffByDocType(
            row.original
          ).dateRange;
          const dateDiff = getDateRangeAndDiffByDocType(
            row.original
          ).humanReadableDiff;

          return (
            <div>
              <div className="flex gap-2">
                <div className="">
                  <p className="text-content-1000 text-sm font-medium">
                    {incomeSource.title}
                  </p>
                  <p className="text-content-400 text-xs font-normal">
                    {incomeSource.subtitle}
                  </p>
                </div>

                <div className="ml-auto">
                  <p className="text-content-1000 text-sm font-medium">
                    {formatToCurrency(row.original.net_monthly_income)}
                  </p>
                </div>
              </div>
              <p className="text-left mt-1 text-sm ">
                {dateRange} - {dateDiff}
              </p>
            </div>
          );
        }}
      />
    </Section>
  );
};
